// @flow

import { PureComponent } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import PropTypes from 'prop-types';

import DisplayText from '../Text/DisplayText';
import cinematicRevealVerticalKeyframes from '../../../keyframes/cinematicRevealVerticalKeyframes';

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  position: relative;
`;

const ClockAnimation = styled.div`
  opacity: 0;
  animation: ${cinematicRevealVerticalKeyframes} 0.3s ease-in-out;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
`;

const AmericanTimeAnimation = styled.div`
  opacity: 0;
  animation: ${cinematicRevealVerticalKeyframes} 0.3s ease-in-out;
  animation-delay: 0.6s;
  animation-fill-mode: forwards;
  position: absolute;
  right: -45px;
  top: 18px;
`;

type Props = {
  usTimeFormat: boolean
};

type State = {
  currentTime: moment | null
};

export default class Clock extends PureComponent<Props, State> {
  componentDidMount() {
    this.setState({ currentTime: moment() });

    this.intervalId = setInterval(() => {
      this.setState({ currentTime: moment() });
    }, 10000);
  }

  componentWillUnount() {
    clearInterval(this.intervalId);
  }

  state = {
    currentTime: null
  };
  intervalId: IntervalID;

  render() {
    if (!this.state.currentTime) {
      return null;
    }

    const format = this.props.usTimeFormat ? 'h:mm' : 'HH:mm';

    return (
      <Container>
        <ClockAnimation>
          <DisplayText fontSize="80px">{this.state.currentTime.format(format)}</DisplayText>
        </ClockAnimation>

        {this.props.usTimeFormat && (
          <AmericanTimeAnimation>
            <DisplayText fontSize="30px">
              {((this.state.currentTime: any): moment).format('A')}
            </DisplayText>
          </AmericanTimeAnimation>
        )}
      </Container>
    );
  }
}

Clock.propTypes = {
  usTimeFormat: PropTypes.bool
};
